import { Checkbox, FormControlLabel } from "@mui/material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { centsToDollarsDisplay } from "../../../common/helpers/stringUtils";
import Condition from "../../../components/Conditional/Condition";
import I18nText from "../../../components/I18nText/I18nText";
import { useCartContext } from "../../../contexts/CartServiceContext/CartServiceContext";
import { useTakeawayItemByob } from "./useTakeawayItemByob";

const CartTakeawayItem = (): ReactElement => {
	const { t } = useTranslation();

	const {
		state: { is_takeaway, order_level_takeaway_fee, takeaway_byob },
	} = useCartContext((state) => state);

	const takeaway_txt = t("DiningOptionsPage.takeaway");
	const byob_txt = t("cartPage.byob");

	const updateByob = useTakeawayItemByob();

	return (
		<Condition check={is_takeaway}>
			<li className="CartItem CartTakeawayItem">
				<div className="ItemHeader">
					<I18nText className="ItemNameText" enText={takeaway_txt} cnText={takeaway_txt} />
					<div className="ItemHeaderRight">
						<span className="Price TabularNums">{`$${centsToDollarsDisplay(order_level_takeaway_fee)}`}</span>
					</div>
				</div>
				<div className="ItemContents">
					<FormControlLabel
						className="TakeawayText"
						control={<Checkbox checked={takeaway_byob} />}
						label={byob_txt}
						onChange={updateByob}
					/>
				</div>
			</li>
		</Condition>
	);
};

export default CartTakeawayItem;
